import ITeamState from "./state";
import {ILink} from "./types";
import * as moment from "moment";

export const getWebsocketHref = (state:ITeamState): string | undefined => {
    if(state.team === undefined) {
        return undefined;
    }

    const websocket:ILink | undefined = state.team.links.find((l:ILink) => l.rel === "events");

    if(!websocket) {
        return undefined;
    }

    return websocket.link;
};

export const isInTeam = (state:ITeamState) => typeof state.team !== 'undefined';

export const isTimerRunning = (state:ITeamState) => {
    if(state.team === undefined || state.team.timer === undefined) {
        return false;
    }

    const duration = state.team.timer.duration / 1000000; // nanoseconds -> milliseconds
    const start = moment(state.team.timer.start);

    const end = start.add(duration as any, 'milliseconds');

    return end.diff(moment()) > 0;
};

export default {
    getWebsocketHref,
    isInTeam
};



// WEBPACK FOOTER //
// ./src/redux/modules/team/selectors.ts